import styled from "styled-components";
import http from "../../../services/httpService";
import { colors } from "../../../theme";

export const generateFile = async (value) => {
  let { data } = await http.post(
    "business/download_mis_for_data_collection/",
    { async_task_id: value },
    { responseType: "blob" }
  );
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(new Blob([data]));
  link.download = "collected_data.xlsx";

  // Append link to the DOM and click it
  document.body.appendChild(link);
  link.click();

  // Clean up
  document.body.removeChild(link);
  window.URL.revokeObjectURL(link.href);
};

export const fetchDataCollection = async (
  setLoading,
  setEmptyData,
  setTableData
) => {
  setLoading(true);
  try {
    const { data } = await http.get("business/data_collection_history_info/");
    console.log(data);
    if (data == "No Batches to Show") {
      setEmptyData(true);
    }
    setTableData(data);
    setLoading(false);
  } catch (e) {
    console.log(e);
  }
};

export const MaterialTableContainer = {
  borderRadius: "14px !important",
  scrollbarWidth: "thin",
};

export const MaterialTable = {
  tableLayout: "fixed",
  border: "none",
  borderCollapse: "separate",
  "*": {
    fontSize: "14px !important",
  },
};


export const HeaderRow = {
    backgroundColor: "rgb(241, 243, 246)",
    borderBottom: "none",
    fontFamily: "Inter",
    whiteSpace: "nowrap",
    color: colors.primaryColor,
    paddingTop: "24px",
    paddingBottom: "24px",
    overflow: "hidden",
    wordWrap: "break-word",
  };

  export const Link = styled.a`
    color: ${colors.linkColor};
    font-family: 'Inter';
    font-weight: 500;
    overflow-wrap: break-word;
    text-decoration: underline;
    cursor: pointer;
`